var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.115A4.615 4.615 0 0 1 5.615 5.5a2.77 2.77 0 0 0 2.216-1.108l.729-.972c.528-.704.792-1.056 1.127-1.31a3 3 0 0 1 .99-.495C11.08 1.5 11.52 1.5 12.4 1.5h3.2c.88 0 1.32 0 1.724.115a3 3 0 0 1 .99.495c.334.254.598.606 1.126 1.31l.73.972A2.77 2.77 0 0 0 22.384 5.5 4.615 4.615 0 0 1 27 10.115V17.5c0 2.8 0 4.2-.545 5.27a5 5 0 0 1-2.185 2.185c-1.07.545-2.47.545-5.27.545H9c-2.8 0-4.2 0-5.27-.545a5 5 0 0 1-2.185-2.185C1 21.7 1 20.3 1 17.5v-7.385ZM20 14.5a6 6 0 1 1-12 0 6 6 0 0 1 12 0ZM14 18a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto28);
export default __webpack_public_path__ + "static/media/photo_28.57ce8dff.svg";
export { ForwardRef as ReactComponent };